exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".rootWebinars[data-v-93b7efe4]{position:relative}.rootWebinars .vkRoot[data-v-93b7efe4]{position:absolute;right:0;top:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-93b7efe4","scoped":true,"hasInlineConfig":true}!./node_modules/stylus-loader!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/profile/modules/remote-edu/views/webinars/Webinars.vue
// module id = 03047c476d1c1c53a304
// module chunks = 12